import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { applyCurrentTheme } from '@/lib/themePreference'
import { AnalyticsProvider } from '@/lib/posthog'
import { AppErrorBoundary } from '@/components/ui/ErrorBoundary'
import App from './App'
import './index.css'

applyCurrentTheme()

const root = document.getElementById('root')
if (!root) throw new Error('No se encontró el elemento root')

createRoot(root).render(
  <StrictMode>
    <AnalyticsProvider>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </AnalyticsProvider>
  </StrictMode>
)
